import React, { useEffect } from "react";
import CustomInput from "./CustomInput";
import { useTranslation } from "react-i18next";

const InputArray = ({ value, label, name, onChange, onBlur, disabled }) => {

  const {t} = useTranslation();

  return (
    <div key={name} className="child-register-repeat-block">
      <div className="child-register-repeat-header">
        <p
          style={{
            marginBottom: "0px",
            marginRight: "10px",
            fontSize: "14px",
            fontWeight: "bold",
          }}>
          {t(label)}
        </p>
        {disabled ? null : (
          <button
            type="button"
            onClick={() => onChange({ target: { id: name } }, null, "add")}
            style={{ border: "none", backgroundColor: "transparent" }}>
            <i className="fas fa-plus fa-sm"></i>
          </button>
        )}
      </div>
      {value
        ? value.map((ele, index) => (
            <div className="child-register-repeat-row child-register-repeat-row-single" key={index}>
              <CustomInput
                name={name}
                value={ele}
                type={ele.type}
                label={label}
                onBlur={onBlur}
                disabled={disabled}
                onChange={(event) => onChange(event, index, "change")}
              />
              <button
                type="button"
                onClick={() => onChange({ target: { id: name } }, index, "remove")}
                disabled={disabled}
                className="child-register-remove-row">
                <i className="fas fa-trash-alt fa-lg"></i>
              </button>
            </div>
          ))
        : null}
    </div>
  );
};

export default InputArray;
